module.exports = __webpack_public_path__ + "static/media/8-hybrid.b5a37aa7.png";